module.exports = __webpack_public_path__ + "media/assets/svgs/settings-white-a55eadae65eb1eda78e930a29399cab9.svg";